<template>
  <div class="tab">
    <span
      v-for="(item, index) in data"
      :key="index"
      :class="tabval === item.num ? 'setectBg' : ''"
      @click="change(item, index)"
      >{{ item.name }}</span
    >
  </div>
</template>

<script>
export default {
  name: "Pageination",
  props: {
    tabval: {
      type: Number,
      default: 7,
    },

    data: {
      type: Array,
      default: () => {
        return [
          {
            num: 7,
            name: "近七天",
          },
          {
            num: 30,
            name: "月",
          },
          {
            num: 365,
            name: "年",
          },
        ];
      },
    },
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    //   tab选择
    change(item, index) {
      this.$emit("change", item, index);
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.tab {
  text-align: center;

  span {
    display: inline-block;
    height: 23px;
    border: 1px solid #0bc4e9;
    font-size: 14px;
    line-height: 23px;
    color: #fff;
    cursor: pointer;
    margin: 5px;
    border-radius: 6px;
  }

  .setectBg {
    background: rgba(10, 167, 255, 0.6);
  }
}
</style>